<div class="au-breadcrumbs-container">
	<nav>
		@for (item of breadcrumbs(); track item; let last = $last) {
			<div class="font-title-medium">
				@if (item.path) {
					<a class="breadcrumb-link" [routerLink]="item.path">{{
						item.label | translate
					}}</a>
				} @else {
					<span>{{ item.label | translate }}</span>
				}
			</div>
			@if (!last) {
				<mat-icon>navigate_next</mat-icon>
			}
		}
	</nav>

	@if (menu()?.items) {
		<div mat-ripple class="ripple-container" [matMenuTriggerFor]="menuTrigger">
			<mat-icon svgIcon="more_vert"></mat-icon>
		</div>
	}
</div>

<mat-menu #menuTrigger="matMenu" class="au-mat-menu-actions-list" xPosition="after">
	<div class="breadcrumbs-actions-menu">
		@for (menuItem of menu()?.items; track menuItem.name) {
			@if (menuItem.divider) {
				<mat-divider />
			}
			<div
				class="menu-action"
				(click)="menuItem.action()"
				[ngClass]="menuItem.colorPalette + '-action'"
			>
				<mat-icon [svgIcon]="menuItem.icon"></mat-icon>
				<span>{{ menuItem.name | translate }}</span>
			</div>
		}
	</div>
</mat-menu>
